import "./App.css";
import React from "react";
import Header from "./components/header";
import Footer from "./components/footer";
import Home from "./components/home";
import Home2 from "./components/home2";
import Item from "./components/item";
import Explore from "./components/explore";
import Activity from "./components/activity";
import Wallet from "./components/wallet";
import Create from "./components/createItem";
import Blog from "./components/blog";
import PostDetails from "./components/post-details";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
function App() {
  return (
    <Router>
      <div className="wrapper">
        <Header />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/home">
            <Home />
          </Route>
          <Route exact path="/home2">
            <Home2 />
          </Route>
          <Route exact path="/item">
            <Item />
          </Route>
          <Route exact path="/explore">
            <Explore />
          </Route>
          <Route exact path="/activity">
            <Activity />
          </Route>

          <Route exact path="/wallet">
            <Wallet />
          </Route>
          <Route exact path="/create">
            <Create />
          </Route>
          <Route exact path="/blog">
            <Blog />
          </Route>

          <Route exact path="/post-details">
            <PostDetails />
          </Route>
        </Switch>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
